import * as Toolkit from '../../toolkit/index';
import RenderWarning from './render';
import { makeWarningList, pieceWarningStr } from './warningData';

// 层板警告信息
export function layerWarning(cube: CubeNode): void {
    let warningList: Array<string> = makeWarningList(cube);

    if (!warningList.length) {
        return;
    }

    let warningStr: string = pieceWarningStr(warningList);
    let warningTxtFontSize: number = Toolkit.computeFontSize({
        // todo: 宽高从坐标系统取，减少dom操作，优化性能
        continerWidth: cube.jView.width(),
        continerHeight: cube.jView.height() - 10,
        strLength: warningStr.length,
        maxFontSize: 12
    });

    RenderWarning({
        cube,
        warningTxtFontSize,
        warningStr,
        warningList
    });
}
